(function ($) {
	'use strict';

	var SCROLL_TIMING = 600;
	var $htmlBody = $('html, body');
	var $container;
	var $window = $(window);
	var $toggle = $('.jump-links-toggle');
	var $chapterMenu = $('.chapter-menu');
	var DEFAULT_LABEL = 'Expand Menu';
	var CLOSE_LABEL = 'Collapse Menu';
	var $headerHeight = $('.cc--header').outerHeight();
	var mediaQuery = '(min-width: 768px)';
	var mediaQueryList = window.matchMedia(mediaQuery);

	var checkBreakpoint = function () {
		if (mediaQueryList.matches === true) {
			$toggle.attr('aria-hidden', 'true');
		} else {
			$toggle.attr('aria-hidden', 'false');
		}
	};

	mediaQueryList.addEventListener('change', checkBreakpoint);
	checkBreakpoint.apply(mediaQueryList);

	var jumpLinks = function(context) {

		$container = $(this);

		var $menuContainer = $('.chapter-menu', $container);
		var $links = $menuContainer.find('a');
		var hashParams;

		var selectChapter = function ($links) {
			if (window.location.hash) {
				hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
				var $selectedLink = $links.toArray().reduce(function (acc, link) {
				var $link = $(link);
				var id = $link.attr('href');
				acc = acc || (id === '#' + hashParams.get('chapter') ? $link : false);
				return acc;
				}, false);
				if ($selectedLink) {
				$selectedLink.click();
				}
			}
		};

		if ($links.length === 0) {
			return;
		}

		// click on toggle
		$toggle.on('click', function (e) {
			toggleLandingpageMenu(this);
		});

		var currentWidth = $(window).width();

		$(window).on('resize', function (e) {
			if (currentWidth != $(window).width()) {
				if ($chapterMenu.hasClass('is-active')) {
					toggleLandingpageMenu($toggle);
				}
			}
			currentWidth = $(window).width();
		});

		var toggleLandingpageMenu = function (el) {
			if (!$chapterMenu.hasClass('is-active')) {
				$(el).attr('aria-label', DEFAULT_LABEL);
			}

			$chapterMenu.toggleClass('is-active');
			$(el).toggleClass('is-active');
			$(el).attr('aria-label', CLOSE_LABEL);
		};

		$links.on('click', function (e) {
			let isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
			let spacing = isIOS ? 0 : 30;
			var $header = $('.cc--header');
			$headerHeight = $header.outerHeight();

			e.preventDefault();
			var target = $(this);
			hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
			var targetHref = target.attr('href');
			var scrollTop = $(document).scrollTop();

			if (scrollTop > $(targetHref).offset().top) {
				spacing += $headerHeight;
			}

			var scrollPos = $(targetHref, $('.content-main')).offset().top - spacing;

			$chapterMenu.toggleClass('is-active');
			$toggle.toggleClass('is-active');

			$htmlBody.stop().animate({ scrollTop: scrollPos }, SCROLL_TIMING);
			hashParams.set('chapter', targetHref.replace('#', ''));
			window.location.hash = hashParams.toString();
		});

		selectChapter($links);
		calculateScroll();

		$(window).on('scroll.chapteredMenu', function () {
			calculateScroll();
		});
	};

	function calculateScroll() {
		var $header = $('.cc--header');
		var $headerHeight = $('.cc--header').outerHeight();

		if ($header.hasClass('scroll-up')) {
		$('.cc--chapter-jump-links').css('top', $headerHeight + 30 + 'px');
		} else {
		$('.cc--chapter-jump-links').css('top', '30px');
		}

		$('.chapter-menu a.is-active', $container).removeClass('is-active');

		$('.chaptered-nav-anchor').each(function (i, el) {
		var $el = $(el);
		var $wrapper = $el.closest('.c--chapter');
		var elementTop = $el.offset().top;
		var viewportTop = $window.scrollTop();
		var viewportHeight = $window.height();
		var additionalOffset = 0;

		if ($wrapper.height() > viewportHeight) {
			additionalOffset = $wrapper.height() / 1.5;
		} else if ($wrapper.height() >= 125) {
			additionalOffset = 300;
		}

		if ($el.attr('id')) {
			if (
				elementTop + additionalOffset - viewportTop >= $headerHeight &&
				elementTop - viewportTop <= viewportHeight
			) {
				var id = $el.attr('id');
				$('.chapter-menu a.is-active', $container).removeClass('is-active');
				$('.chapter-menu a[href="' + '#' + id + '"]', $container).addClass('is-active');
				return false;
			}
		}
		});
	}

	// Set top position of jump links nav according to header height
	$('.cc--chapter-jump-links').css('top', $headerHeight + 30 + 'px');

	window.DP.behaviors.chapteredPage = {
		attach: function (context) {
			$(context).find('body.page-template-page-chaptered').once('jumpLinks')
			.each(function () {
				jumpLinks.apply(this);
			});
		},
	};

})(jQuery);
